import {Component, EventEmitter} from '@angular/core';
import {ECpmCObjectStoreEntryProxyTypeApiEnum} from '../../../../gen/cpm-c-api-ts/src/enums/c-customer/cpmc-object-store-entry-proxy.api-enums';
import {CpmCObjectStoreEntryProxyApiModel} from '../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-object-store-entry-proxy.api-model';
import {IDataCellDisplayComponent} from '../../../../sdk/src/data-cell-display/idata-cell-display/idata-cell-display.component';
import {EDialogOpenMode} from '../../../../sdk/src/enums/dialog-open-mode.enum';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {
    NewEditObjectStoreEntryModalComponent,
    NewEditObjectStoreEntryModalConfig
} from '../../modals/new-edit-object-store-entry-modal/new-edit-object-store-entry-modal.component';

/**
 * Static extra information, independent of value modification
 */
export class ObjectStoreValueDataCellDisplayExtra {
    constructor(
        public forceRefreshData = false,
        public openDialogMode: EDialogOpenMode = EDialogOpenMode.READ_ONLY,
        public linkObjectType?: string,
        public linkObjectUUID?: string,
        public updated?: EventEmitter<boolean>,
        public initialData?: CpmCObjectStoreEntryProxyApiModel
    ) {}
}

/**
 * ObjectStore entry data cell display component
 * /!\ fnCustomData is used for passing the version to the modal config, as the value is used for the value itself,
 * /!\ and the version is needed for display in the modal header and for concurrency management in edition mode
 */
@Component({
    templateUrl: './object-store-value-cell-display.component.html',
    imports: [PrimeNgImportsModule]
})
export class ObjectStoreValueDataCellDisplayComponent extends IDataCellDisplayComponent<
    CpmCObjectStoreEntryProxyApiModel,
    ObjectStoreValueDataCellDisplayExtra
> {
    protected readonly ECpmCObjectStoreEntryProxyTypeApiEnum = ECpmCObjectStoreEntryProxyTypeApiEnum;

    protected _osModel?: CpmCObjectStoreEntryProxyApiModel;
    protected _modalConfig?: NewEditObjectStoreEntryModalConfig;
    protected _parsedValue?: unknown;

    // ===============================================================
    // ===============================================================

    /**
     * On refresh (Error handling and refresh is done in the parent)
     */
    protected override async onRefresh(): Promise<void> {
        this._osModel = this.row as CpmCObjectStoreEntryProxyApiModel;
        const version = this.value as number;
        this._parsedValue = undefined;
        // build input config in order to prepare modal
        if (this.extra) {
            this._modalConfig = new NewEditObjectStoreEntryModalConfig(
                this.extra.linkObjectType,
                this.extra.linkObjectUUID,
                this._osModel,
                this.extra.forceRefreshData,
                version,
                () => this.extra?.initialData !== this._osModel?.value
            );
        }

        if (this._osModel?.value) {
            this._parsedValue = JSON.parse(this._osModel?.value);
        }
    }

    /**
     * Action to open a #NewEditObjectStoreEntryModalComponent modal for complex objects
     */
    protected clickOnDetailsViewLink() {
        if (!this._modalConfig) {
            console.error('No extra configured');
            return;
        }
        this.globalsService.dialogService
            .open(
                NewEditObjectStoreEntryModalComponent,
                NewEditObjectStoreEntryModalComponent.getDialogServiceParameters({
                    dialogOpenMode: this.extra!.openDialogMode,
                    extended: this._modalConfig,
                    duplicate: true // allow opening even if a dialog of the same type is already open,
                })
            )
            // Trigger on event when modification was confirmed in the modal
            .onClose.subscribe((result: boolean) => {
                if (this.extra?.updated && result) {
                    this.extra.updated.emit(true);
                }
            });
    }
}
